import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {Card, CardHeader, CardTitle, CardContent,} from '../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow, } from '../components/ui/table';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { Truck, Check, Package, Plus, Trash, CircleArrowLeft, Circle, MoreVertical, ClipboardPen, StepForward, ChevronDown, ChevronRight, MapPin, Calendar, User, Briefcase, DollarSign, Fuel, Phone, Receipt, ReceiptIcon, RectangleEllipsis, TrafficCone, ChevronLeft } from 'lucide-react';
import logoamerisa from '../assets/logoamerisa.png';
import Modal from "../components/Modal";
import Input from "../components/ui/Input";
import { Modal as Miuimodal, Box, Typography, TextField, Stack, IconButton } from '@mui/material';
import Sidebar from '../components/Sidebar'; // Importa el Sidebar
import SettingModal from "../components/SettingModal";
import { Select, MenuItem, InputLabel, FormControl, Checkbox, ListItemText, OutlinedInput, Autocomplete } from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { PDFDownloadLink, pdf } from '@react-pdf/renderer';
import InstructionLetterPDF from '../components/Cartadeinstruccion';
import ModalEstatus from '../components/acciones/ModalEstatus';
import Topbar from '../components/Topbar';
import { es } from 'date-fns/locale';
import ModalEntrega from '../components/acciones/ModalEntrega';
import { 
  getShipments, 
  deleteShipment, 
  notifyTransporterSMS, 
  notifyTransporter,
  getWarehouses, 
  getVendors, 
  getShipmentWithOrders, 
  getShipmentComments, 
  addShipmentComment, 
  getShipmentWithOrdersProducts,
  getTransportLines,
  getDriversByLine,
  getAvailableOrdersForShipment,
  revertShipment as apiRevertShipment,
  getUserProfile,
  getVehiclesByLineId,
  getTrailersByTransportLine,
  getAdicionales, // Add this import
  registerShipmentCosts, // Changed from createCostRecord
  getShipmentCosts, // Add this import
  updateShipmentCost, // Add this import
  deleteShipmentCost, // Add this import
  getActiveShipments, // <--- Asegura la importación aquí
  putShipmentOnHold, // Add this import
  removeShipmentFromHold, // Add this import
} from '../api';
import axios from 'axios';
const filterStyle = {
  backgroundColor: 'white',
  borderRadius: '4px',
  border: '1px solid #d1d5db',
  minWidth: '180px',
  height: '38px',
  '&:hover': {
    borderColor: '#9ca3af',
  },
};

// Componente ConfirmationModal
const ConfirmationModal = ({ isOpen, onClose, onConfirm, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Confirmar Reversión</h2>
        <p className="mb-4">{message}</p>
        <div className="flex justify-end space-x-2">
          <Button onClick={onClose} variant="outline">
            Cancelar
          </Button>
          <Button onClick={onConfirm} variant="destructive">
            Confirmar
          </Button>
        </div>
      </div>
    </div>
  );
};

// Componente para el modal de comentarios
const CommentsModal = ({ isOpen, onClose, comments, onAddComment }) => {
  const [newComment, setNewComment] = useState('');
  const userName = localStorage.getItem('userName') || 'Usuario';

  const handleAddComment = () => {
    if (newComment.trim()) {
      onAddComment(newComment, userName);
      setNewComment('');
    }
  };

  return (
    <Miuimodal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: 24,
          p: 4,
        }}
      >
        {/* Add close button (X) in the top right corner */}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </IconButton>
        
        <Typography variant="h6" component="h2">
          Historial de Comentarios
        </Typography>
        <Box sx={{ maxHeight: 300, overflowY: 'auto', mt: 2 }}>
          {comments.map((comment, index) => (
            <Box key={index} sx={{ mb: 2, p: 2, bgcolor: 'rgba(0, 0, 0, 0.03)', borderRadius: 1 }}>
              <Typography variant="subtitle2" color="primary" fontWeight="bold">
                {comment.user}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {new Date(comment.created_at).toLocaleString()}
              </Typography>
              <Typography variant="body1">{comment.text}</Typography>
            </Box>
          ))}
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="textSecondary" mb={1}>
            Comentando como: {userName}
          </Typography>
          <Input
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            placeholder="Añadir comentario"
            fullWidth
          />
          <Button onClick={handleAddComment} variant="primary" sx={{ mt: 1 }}>
            Añadir
          </Button>
        </Box>
      </Box>
    </Miuimodal>
  );
};

// Component for the additional costs modal
const AdditionalCostsModal = ({ isOpen, onClose, shipmentRef }) => {
  const [costs, setCosts] = useState([]);
  const [newCost, setNewCost] = useState({
    concept: '',
    amount: '',
    description: ''
  });
  const [conceptOptions, setConceptOptions] = useState([]);
  const [isLoadingConcepts, setIsLoadingConcepts] = useState(false);
  const [isLoadingExistingCosts, setIsLoadingExistingCosts] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState(null);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [editMode, setEditMode] = useState({});
  // Add new state variables for deletion confirmation
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [costToDelete, setCostToDelete] = useState(null);

  // Fetch concepts and existing costs when modal opens
  useEffect(() => {
    if (isOpen && shipmentRef?.id) {
      fetchConcepts();
      fetchExistingCosts();
    }
  }, [isOpen, shipmentRef]);

  // Reset state when modal closes
  useEffect(() => {
    if (!isOpen) {
      // Clear all state when modal is closed
      setCosts([]);
      setNewCost({
        concept: '',
        amount: '',
        description: ''
      });
      setSaveError(null);
      setSaveSuccess(false);
      setEditMode({});
    }
  }, [isOpen]);

  const fetchConcepts = async () => {
    setIsLoadingConcepts(true);
    try {
      const adicionales = await getAdicionales();
      setConceptOptions(adicionales);
    } catch (error) {
      console.error("Error fetching concepts:", error);
    } finally {
      setIsLoadingConcepts(false);
    }
  };

  const fetchExistingCosts = async () => {
    if (!shipmentRef?.id) return;
    
    setIsLoadingExistingCosts(true);
    try {
      const existingCosts = await getShipmentCosts(shipmentRef.id);
      
      // Transform API data to match the UI format
      const formattedCosts = existingCosts.map(cost => ({
        id: cost.id,
        concept: cost.concepto || '',
        amount: cost.costo || 0,
        description: cost.notas || '',
        // Keep the original data for reference
        originalData: cost
      }));
      
      setCosts(formattedCosts);
    } catch (error) {
      console.error("Error fetching existing costs:", error);
    } finally {
      setIsLoadingExistingCosts(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCost(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAddCost = () => {
    if (!newCost.concept || !newCost.amount) return;
    
    // Check if this concept already exists
    const conceptExists = costs.some(cost => cost.concept === newCost.concept);
    if (conceptExists) {
      setSaveError(`Ya existe un costo con concepto "${newCost.concept}"`);
      setTimeout(() => setSaveError(null), 3000);
      return;
    }
    
    setCosts(prev => [
      ...prev, 
      {
        ...newCost,
        id: `new-${Date.now()}`, // temporary id for UI purposes
        amount: parseFloat(newCost.amount)
      }
    ]);
    
    // Reset form
    setNewCost({
      concept: '',
      amount: '',
      description: ''
    });
  };

  const handleRemoveCost = (costId) => {
    setCosts(costs.filter(cost => cost.id !== costId));
  };

  // Enable edit mode for a specific cost
  const handleEditStart = (costId) => {
    setEditMode(prev => ({
      ...prev,
      [costId]: true
    }));
  };

  // Cancel edit mode for a specific cost
  const handleEditCancel = (costId) => {
    setEditMode(prev => ({
      ...prev,
      [costId]: false
    }));
  };

  // Handle changes to a cost being edited
  const handleCostChange = (costId, field, value) => {
    setCosts(prev => 
      prev.map(cost => 
        cost.id === costId 
          ? { 
              ...cost, 
              [field]: field === 'amount' ? parseFloat(value) : value,
              modified: true // Mark as modified for existing records
            } 
          : cost
      )
    );
  };

  // Replace direct confirm with showing our custom dialog
  const handleDeleteCost = (costId) => {
    setCostToDelete(costId);
    setIsDeleteConfirmOpen(true);
  };
  
  // New function to actually delete the cost after confirmation
  const confirmDeleteCost = async () => {
    try {
      // For existing cost records (ones with originalData)
      const costToDeleteObj = costs.find(cost => cost.id === costToDelete);
      if (costToDeleteObj && costToDeleteObj.originalData) {
        await deleteShipmentCost(costToDelete);
        setCosts(costs.filter(cost => cost.id !== costToDelete));
        setSaveSuccess(true);
        setTimeout(() => setSaveSuccess(false), 1500);
      }
    } catch (error) {
      console.error('Error deleting cost record:', error);
      setSaveError(`Error al eliminar el costo: ${error.message || 'Error desconocido'}`);
      setTimeout(() => setSaveError(null), 3000);
    } finally {
      setIsDeleteConfirmOpen(false);
      setCostToDelete(null);
    }
  };
  
  // Function to cancel the delete operation
  const cancelDeleteCost = () => {
    setIsDeleteConfirmOpen(false);
    setCostToDelete(null);
  };

  const handleSaveAllCosts = async () => {
    if (costs.length === 0) {
      return;
    }
    
    setIsSaving(true);
    setSaveError(null);
    setSaveSuccess(false);
    
    try {
      // Group costs into existing (need update) and new (need create)
      const existingCosts = costs.filter(cost => cost.originalData && cost.modified);
      const newCosts = costs.filter(cost => !cost.originalData);
      
      // Update existing costs that have been modified
      for (const cost of existingCosts) {
        const costData = {
          concepto: cost.concept,
          costo: cost.amount,
          notas: cost.description,
        };
        
        await updateShipmentCost(cost.id, costData);
      }
      
      // Create new costs
      for (const cost of newCosts) {
        const costData = {
          shipment_id: shipmentRef.id,
          viaje: shipmentRef.reference,
          concepto: cost.concept,
          costo: cost.amount,
          notas: cost.description,
          cliente: shipmentRef.customer || null,
          cuenta: shipmentRef.vendor || null,
          origen: shipmentRef.origin || null,
          destino: shipmentRef.destination || null,
          linea_transporte: shipmentRef.Lt || null,
          tipo_vehiculo: shipmentRef.vehicle_type || null
        };
        
        await registerShipmentCosts(shipmentRef.id, costData);
      }
      
      console.log(`Saved ${existingCosts.length} updated costs and ${newCosts.length} new costs`);
      setSaveSuccess(true);
      
      // Close modal after short delay to show success message
      setTimeout(() => {
        onClose();
      }, 1500);
      
    } catch (error) {
      console.error('Error saving additional costs:', error);
      setSaveError(`Error al guardar costos: ${error.message || 'Error desconocido'}`);
    } finally {
      setIsSaving(false);
    }
  };

  const handleModalClose = () => {
    // Clear all state when manually closing
    setCosts([]);
    setNewCost({
      concept: '',
      amount: '',
      description: ''
    });
    setSaveError(null);
    setSaveSuccess(false);
    setEditMode({});
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold">Costos Adicionales</h2>
          <button 
            onClick={handleModalClose}
            className="text-gray-500 hover:text-gray-700"
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div className="mb-6">
          <p className="text-gray-700 mb-2">Embarque: <span className="font-semibold">{shipmentRef?.reference}</span></p>
          
          {/* Form to add new cost */}
          <div className="grid grid-cols-3 gap-3 mt-4 mb-4 border p-4 rounded-lg bg-gray-50">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Concepto</label>
              {isLoadingConcepts ? (
                <div className="w-full p-2 border rounded bg-gray-100 flex items-center justify-center">
                  <svg className="animate-spin h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </div>
              ) : (
                <select
                  name="concept"
                  value={newCost.concept}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded"
                >
                  <option value="">Seleccione un concepto</option>
                  {conceptOptions.map(concept => (
                    <option 
                      key={concept.id} 
                      value={concept.concepto}
                      disabled={costs.some(cost => cost.concept === concept.concepto)}
                    >
                      {concept.concepto} {costs.some(cost => cost.concept === concept.concepto) ? '(ya agregado)' : ''}
                    </option>
                  ))}
                  {/* Add an option for "FLETE" if it's not in the database */}
                  {!conceptOptions.some(c => c.concepto === "FLETE") && !costs.some(cost => cost.concept === "FLETE") && (
                    <option value="FLETE">FLETE</option>
                  )}
                </select>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Monto</label>
              <input
                type="number"
                name="amount"
                value={newCost.amount}
                onChange={(e) => handleInputChange(e)}
                className="w-full p-2 border rounded"
                placeholder="0.00"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Descripción</label>
              <input
                type="text"
                name="description"
                value={newCost.description}
                onChange={(e) => handleInputChange(e)}
                className="w-full p-2 border rounded"
                placeholder="Descripción opcional"
              />
            </div>
          </div>
          
          <button 
            onClick={handleAddCost}
            className="w-full py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          >
            + Agregar Costo
          </button>
        </div>
        
        {/* List of added costs */}
        <div className="mb-6">
          <h3 className="font-semibold mb-2">Costos Agregados</h3>
          {isLoadingExistingCosts ? (
            <div className="flex justify-center items-center p-4">
              <svg className="animate-spin h-6 w-6 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span className="ml-2">Cargando costos existentes...</span>
            </div>
          ) : costs.length === 0 ? (
            <p className="text-gray-500 italic">No hay costos adicionales agregados</p>
          ) : (
            <div className="overflow-y-auto max-h-60 border rounded">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Concepto</th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Monto</th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Descripción</th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acción</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {costs.map(cost => (
                    <tr key={cost.id} className={cost.originalData && !editMode[cost.id] ? "bg-gray-50" : ""}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {editMode[cost.id] ? (
                          <select
                            value={cost.concept}
                            onChange={(e) => handleCostChange(cost.id, 'concept', e.target.value)}
                            className="w-full p-2 border rounded"
                            disabled={cost.concept === "FLETE"} // Don't allow changing FLETE concept
                          >
                            {conceptOptions.map(concept => (
                              <option 
                                key={concept.id} 
                                value={concept.concepto}
                                disabled={costs.some(c => c.id !== cost.id && c.concept === concept.concepto)}
                              >
                                {concept.concepto}
                              </option>
                            ))}
                            {!conceptOptions.some(c => c.concepto === "FLETE") && (
                              <option value="FLETE">FLETE</option>
                            )}
                          </select>
                        ) : (
                          cost.concept
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {editMode[cost.id] ? (
                          <input
                            type="number"
                            value={cost.amount}
                            onChange={(e) => handleCostChange(cost.id, 'amount', e.target.value)}
                            className="w-full p-2 border rounded"
                            placeholder="0.00"
                          />
                        ) : (
                          `$${cost.amount.toFixed(2)}`
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {editMode[cost.id] ? (
                          <input
                            type="text"
                            value={cost.description || ''}
                            onChange={(e) => handleCostChange(cost.id, 'description', e.target.value)}
                            className="w-full p-2 border rounded"
                            placeholder="Descripción"
                          />
                        ) : (
                          cost.description || '-'
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {cost.originalData ? (
                          // For existing costs
                          editMode[cost.id] ? (
                            <div className="flex space-x-2">
                              <button 
                                onClick={() => handleEditCancel(cost.id)} 
                                className="text-gray-600 hover:text-gray-800"
                                title="Cancelar"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                              </button>
                              <button 
                                onClick={() => setEditMode({...editMode, [cost.id]: false})}
                                className="text-green-600 hover:text-green-800"
                                title="Guardar"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                              </button>
                            </div>
                          ) : (
                            <div className="flex space-x-2">
                              <button 
                                onClick={() => handleEditStart(cost.id)}
                                className="text-blue-600 hover:text-blue-800"
                                title="Editar"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                              </button>
                              {cost.concept !== "FLETE" && (
                                <button 
                                  onClick={() => handleDeleteCost(cost.id)}
                                  className="text-red-600 hover:text-red-800"
                                  title="Eliminar"
                                >
                                  <Trash className="h-4 w-4" />
                                </button>
                              )}
                            </div>
                          )
                        ) : (
                          // For new costs
                          <button 
                            onClick={() => handleRemoveCost(cost.id)}
                            className="text-red-600 hover:text-red-800"
                            title="Eliminar"
                          >
                            <Trash className="h-4 w-4" />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        
        {/* Total */}
        {costs.length > 0 && (
          <div className="flex justify-end mb-6">
            <div className="text-right">
              <span className="text-sm font-medium text-gray-700">Total:</span>
              <p className="text-lg font-bold">${costs.reduce((sum, cost) => sum + Number(cost.amount), 0).toFixed(2)}</p>
            </div>
          </div>
        )}
        
        {/* Add status messages */}
        {saveSuccess && (
          <div className="mb-4 p-2 bg-green-100 text-green-700 rounded">
            Costos guardados correctamente
          </div>
        )}
        
        {saveError && (
          <div className="mb-4 p-2 bg-red-100 text-red-700 rounded">
            {saveError}
          </div>
        )}
        
        <div className="flex justify-end space-x-2">
          <Button onClick={handleModalClose} variant="outline" disabled={isSaving}>
            Cancelar
          </Button>
          <Button 
            onClick={handleSaveAllCosts} 
            disabled={costs.length === 0 || isSaving}
            className={isSaving ? "opacity-70 cursor-not-allowed" : ""}
          >
            {isSaving ? (
              <>
                <svg className="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Guardando...
              </>
            ) : (
              'Guardar Costos'
            )}
          </Button>
        </div>
        
        {/* Add the confirmation dialog */}
        {isDeleteConfirmOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-4 w-80">
              <h3 className="text-lg font-medium mb-3">Confirmar eliminación</h3>
              <p className="mb-4">¿Estás seguro de que deseas eliminar este costo?</p>
              <div className="flex justify-end space-x-2">
                <button
                  onClick={cancelDeleteCost}
                  className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100"
                >
                  Cancelar
                </button>
                <button
                  onClick={confirmDeleteCost}
                  className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                >
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// Componente Shipments
const Shipments = () => {  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeItem, setActiveItem] = useState('Outbound');
  const [startDate, setStartDate] = useState('');
  const [isSettingModalOpen, setIsSettingModalOpen] = useState(false);
  const [selectedShipmentForSetting, setSelectedShipmentForSetting] = useState(null);
  const [endDate, setEndDate] = useState('');
  const [isAdvancedFiltersExpanded, setIsAdvancedFiltersExpanded] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);  const [availableSubstatuses, setAvailableSubstatuses] = useState([]);
  const [error, setError] = useState(null);
  const [ordersForAssign, setOrdersForAssign] = useState([]);
  const [shipments, setShipments] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  const [shipmentToDelete, setShipmentToDelete] = useState(null);
  const [shipmentToRevert, setShipmentToRevert] = useState(null);
  const [isMiuimodalOpen, setMiuimodalOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [newShipment, setNewShipment] = useState({
    id: "",
    reference: "",
    Truck: "",
    origin: null,
    destination: null,
    customer: null,
    vendor: "",
    status: "PENDING",
    pickup_date: null,
    delivery_date: null,
    vehicle: null,
    driver: null,
    ubication_id: null,
  });
  const [originalShipments, setOriginalShipments] = useState([]);
  const [warehouseData, setWarehouseData] = useState([]);
  const [accountName, setAccountName] = useState('');
  const [accountRole, setAccountRole] = useState('');
  const [completeShipmentData, setCompleteShipmentData] = useState(null);
  const [vehicleCatalog, setVehicleCatalog] = useState([]);
  const [trailerCatalog, setTrailerCatalog] = useState([]);
  const [vehicleData, setVehicleData] = useState({});
  const [trailerData, setTrailerData] = useState({});
  const [expandedShipments, setExpandedShipments] = useState({});
  const [searchValue, setSearchValue] = useState('');
  const [vendorData, setVendorData] = useState([]);
  const [isStatusModalOpen, setStatusModalOpen] = useState(false);
  const [selectedShipmentRef, setSelectedShipmentRef] = useState(null);
  const [isCommentsModalOpen, setCommentsModalOpen] = useState(false);
  const [selectedShipmentComments, setSelectedShipmentComments] = useState([]);
  const [selectedShipmentForComments, setSelectedShipmentForComments] = useState(null);
  const [isActionsModalOpen, setActionsModalOpen] = useState(false);
  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [isEntregaModalOpen, setEntregaModalOpen] = useState(false);
  const [referencia, setReferencia] = useState('');
  const [isAdditionalCostsModalOpen, setAdditionalCostsModalOpen] = useState(false);
  const [selectedShipmentForCosts, setSelectedShipmentForCosts] = useState(null);

  // Estados para paginación
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const toggleShipmentExpand = (shipmentId) => {
    setExpandedShipments(prev => ({
      ...prev,
      [shipmentId]: !prev[shipmentId]
    }));
  };
  
  const handleOpenSettingModal = async (shipment) => {
    setSelectedShipmentForSetting(shipment);
    setIsSettingModalOpen(true);
    try {
      const availableOrders = await getAvailableOrdersForShipment(shipment.id);
      console.log('Órdenes obtenidas:', availableOrders);
      setOrdersForAssign(availableOrders);
    } catch (error) {
      console.error('Error fetching orders:', error);
      setOrdersForAssign([]);
    }
  };
  const handleCloseSettingModal = () => {
    setIsSettingModalOpen(false);
    setSelectedShipmentForSetting(null);
  };

  const handleDeleteShipment = async (shipmentId) => {
    try {
      await deleteShipment(shipmentId);
      setShipments(shipments.filter((shipment) => shipment.id !== shipmentId));
    } catch (error) {
      console.error('Error al eliminar el embarque:', error);
      setError('No se pudo eliminar el embarque.');
    }
  };

const fetchShipments = async () => {
  try {
    setLoading(true);
    setError(null);

    const data = await getShipments(startDate, endDate);

    const sortedData = data.sort((a, b) => {
      if (!a.pickup_date && b.pickup_date) return -1;
      if (a.pickup_date && !b.pickup_date) return 1;
      if (a.pickup_date && b.pickup_date) {
        return new Date(b.pickup_date) - new Date(a.pickup_date);
      }
      return b.id - a.id;
    });

    setOriginalShipments(sortedData);
    setShipments(sortedData);
  } catch (error) {
    console.error('Error al obtener los embarques:', error);
    setError('Error al cargar los embarques. Intente nuevamente.');
  } finally {
    setLoading(false);
  }
};

  // Nueva función para obtener solo embarques activos usando el endpoint optimizado
const fetchActiveShipments = async () => {
  try {
    // Usar el endpoint optimizado
    const data = await getActiveShipments();
    return data;
  } catch (error) {
    console.error('Error al obtener embarques activos:', error);
    return [];
  }
};

  useEffect(() =>{
    const interval = setInterval(async () => {
      if (
        shipments.length > 0 &&
        !isActionsModalOpen &&
        !isCommentsModalOpen &&
        !isConfirmationModalOpen &&
        !isMiuimodalOpen &&
        !isStatusModalOpen &&
        !isEntregaModalOpen
      ) {
        // Recarga optimizada: solo actualizar embarques activos
        const activeShipments = await fetchActiveShipments();
        setShipments(prevShipments => {
          const finalized = prevShipments.filter(s => s.status === 'FINALIZADO' || (s.orders && s.orders.some(o => o.dev_status === 'DEVUELTO')));
          const activeIds = activeShipments.map(s => s.id);
          // Combinar y luego ordenar por pickup_date descendente (más reciente primero)
          const merged = [
            ...activeShipments,
            ...finalized.filter(f => !activeIds.includes(f.id))
          ];
          merged.sort((a, b) => {
            if (!a.pickup_date && b.pickup_date) return 1;
            if (a.pickup_date && !b.pickup_date) return -1;
            if (a.pickup_date && b.pickup_date) {
              return new Date(b.pickup_date) - new Date(a.pickup_date);
            }
            return b.id - a.id;
          });
          setOriginalShipments(prevOriginal => {
            const finalizedOriginal = prevOriginal.filter(s => s.status === 'FINALIZADO' || (s.orders && s.orders.some(o => o.dev_status === 'DEVUELTO')));
            const mergedOriginal = [
              ...activeShipments,
              ...finalizedOriginal.filter(f => !activeIds.includes(f.id))
            ];
            mergedOriginal.sort((a, b) => {
              if (!a.pickup_date && b.pickup_date) return 1;
              if (a.pickup_date && !b.pickup_date) return -1;
              if (a.pickup_date && b.pickup_date) {
                return new Date(b.pickup_date) - new Date(a.pickup_date);
              }
              return b.id - a.id;
            });
            return mergedOriginal;
          });
          return merged;
        });
      }
    }, 30000);
    return () => clearInterval(interval);
  }, [
    isActionsModalOpen,
    isCommentsModalOpen,
    isConfirmationModalOpen,
    isMiuimodalOpen,
    isStatusModalOpen,
    isEntregaModalOpen,
    startDate,
    endDate,
    shipments.length
  ]);
 

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  const getStatusBadge = (status) => {
    const normalizedStatus = status?.toUpperCase().replace(' ', '_');

    const styles = {
      PENDIENTE: 'bg-yellow-100 text-yellow-800',
      EN_CLIENTE: 'bg-indigo-500 text-white whitespace-nowrap',
      ENTREGADO: 'bg-green-100 text-green-800',
      CANCELADO: 'bg-red-100 text-red-800',
      ARRIBADO: 'bg-sky-600 text-white',
      TRANSITO: 'bg-green-500 text-white',
      FINALIZADO: 'bg-green-700 text-white',
      CREADO: 'bg-gray-100 text-gray-800',
      RESGUARDO: 'bg-yellow-400 text-white badge-breathing', // Clase especial para animación
    };

    const statusClass = styles[normalizedStatus] || 'bg-gray-100 text-gray-800';

    return (
      <Badge className={`px-2 py-1 rounded-full text-sm whitespace-nowrap ${statusClass}`}>
        {status || 'N/A'}
      </Badge>
    );
  };

  const handleOpenMiuimodal = (shipmentId) => {
    setShipmentToDelete(shipmentId);
    setMiuimodalOpen(true);
  };

  const handleCloseMiuimodal = () => {
    setShipmentToDelete(null);
    setMiuimodalOpen(false);
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteShipment(shipmentToDelete);
      setShipments((prev) => prev.filter((s) => s.id !== shipmentToDelete));
      handleCloseMiuimodal();
      setSuccessMessage(`El embarque ${shipmentToDelete.reference} se eliminó correctamente.`);
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    } catch (error) {
      console.error('Error deleting shipment:', error);
    }
  };


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    });
  };


  const handleOpenConfirmationModal = (shipment) => {
    setShipmentToRevert(shipment);
    setConfirmationModalOpen(true);
  };

  const handleCloseConfirmationModal = () => {
    setShipmentToRevert(null);
    setConfirmationModalOpen(false);
  };

  const revertShipment = async () => {
    if (!shipmentToRevert) return;

    try {
      await apiRevertShipment(shipmentToRevert.id);

      await fetchShipments();
      setSuccessMessage('Embarque revertido correctamente.');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('Error al revertir el embarque:', error);
      alert('Ocurrió un error al revertir el embarque.');
    } finally {
      handleCloseConfirmationModal();
    }
  };


  const getDevStatusDotColor = (orders) => {
    if (!orders || orders.length === 0) return 'text-gray-400';

    for (const order of orders) {
      if (order.dev_status === 'PENDIENTE') return 'bg-red-500';
      if (order.dev_status === 'TRANSITO') return 'bg-blue-500';
      if (order.dev_status === 'DEVUELTO') return 'bg-green-500';
    } 
    return 'text-gray-400';
  };
  // La función applyFilters ya no es necesaria porque el filtrado se realiza 
  // automáticamente dentro de filteredShipments

  useEffect(() => {
    fetchShipments();
  }, []);

  const getUniqueSubstatuses = (shipments) => {
    const substatuses = shipments.map(shipment => shipment.Substatus);
    return [...new Set(substatuses)];
  };

  const uniqueSubstatuses = getUniqueSubstatuses(shipments);


  const handleOpenCommentsModal = async (shipment) => {
    setSelectedShipmentForComments(shipment);
    try {
      const comments = await getShipmentComments(shipment.id);
      setSelectedShipmentComments(comments);
    } catch (error) {
      console.error('Error fetching comments:', error);
    }
    setCommentsModalOpen(true);
  };

  const handleCloseCommentsModal = () => {
    setCommentsModalOpen(false);
    setSelectedShipmentForComments(null);
  };

  const handleAddComment = async (comment, user) => {
    if (!selectedShipmentForComments) return;

    try {
      const newComment = await addShipmentComment(selectedShipmentForComments.id, {
        text: comment,
        user: user
      });
      
      setSelectedShipmentComments(prev => [...prev, {
        ...newComment,
        user: user
      }]);
    } catch (error) {
      console.error('Error adding comment:', error);
    }
  };

const handleOpenActionsModal = async (shipment) => {
  setSelectedShipmentForSetting(shipment);
  setActionsModalOpen(true);

  try {
    const shipmentData = await getShipmentWithOrdersProducts(shipment.id);

    let transporterEmail = "";
    let vehicleData = {};
    let trailerData = [];
    let driverPhoneNumber = "";

    if (shipment.Lt) {
      const transportLines = await getTransportLines();
      const selectedLt = transportLines.find(lt => lt.name === shipment.Lt);
      
      if (selectedLt) {
        transporterEmail = selectedLt.email || "No disponible";
        
        // Fetch vehicles for this transport line
        try {
          const vehicles = await getVehiclesByLineId(selectedLt.id);
          console.log('Fetched vehicles for transport line:', vehicles);
          
          // Find the specific vehicle for this shipment
          if (shipment.vehicle && vehicles && vehicles.length > 0) {
            const vehicleInfo = vehicles.find(v => v.placas === shipment.vehicle);
            if (vehicleInfo) {
              vehicleData = {
                vehicle: vehicleInfo,
                id: vehicleInfo.id,
                placas: vehicleInfo.placas,
                tipo: vehicleInfo.tipo
              };
            }
          }
          
          // Save the vehicle data for this shipment
          setVehicleData(prev => ({
            ...prev,
            [shipment.id]: vehicleData
          }));
        } catch (error) {
          console.error('Error fetching vehicles:', error);
        }
        
        // Fetch the driver's phone number if we have a driver assigned
        try {
          if (shipment.driver && shipment.driver !== "undefined undefined") {
            const drivers = await getDriversByLine(selectedLt.id);
            console.log('Fetched drivers:', drivers.length);
            
            // Try to find the driver information
            const driverInfo = drivers.find(d => {
              // Create potential name formats
              const fullName = `${d.nombre} ${d.apellido_paterno}`.trim();
              const fullNameWithMaterno = `${d.nombre} ${d.apellido_paterno} ${d.apellido_materno || ''}`.trim();
              const nameReverseFormat = `${d.apellido_paterno} ${d.nombre}`.trim();
              
              return shipment.driver === fullName || 
                    shipment.driver === fullNameWithMaterno ||
                    shipment.driver === nameReverseFormat ||
                    (shipment.driver.includes(d.nombre) && 
                    (d.apellido_paterno ? shipment.driver.includes(d.apellido_paterno) : true));
            });
            
            if (driverInfo && driverInfo.telefono) {
              console.log('Found driver phone for PDF:', driverInfo.telefono);
              driverPhoneNumber = driverInfo.telefono;
            }
          }
        } catch (error) {
          console.error('Error fetching driver phone:', error);
        }
        
        // Fetch trailers for this transport line
        try {
          const trailers = await getTrailersByTransportLine(selectedLt.id);
          console.log('Fetched trailers for transport line:', trailers);
          
          // Filter trailers that may be related to this shipment
          if (trailers && trailers.length > 0) {
            if (shipment.remolque1) {
              const trailer1 = trailers.find(t => t.placas === shipment.remolque1);
              if (trailer1) trailerData.push(trailer1);
            }
            
            if (shipment.remolque2) {
              const trailer2 = trailers.find(t => t.placas === shipment.remolque2);
              if (trailer2) trailerData.push(trailer2);
            }
          }
          
          // Save the trailer data for this shipment
          setTrailerData(prev => ({
            ...prev,
            [shipment.id]: trailerData
          }));
        } catch (error) {
          console.error('Error fetching trailers:', error);
        }
      }
    }

    // Add email, vehicle, and driver information to shipment data
    shipmentData.transporterEmail = transporterEmail;
    shipmentData.vehicleInfo = vehicleData;
    shipmentData.trailerInfo = trailerData;
    shipmentData.driver_phone = driverPhoneNumber;
    
    if (vehicleData && vehicleData.tipo) {
      shipmentData.vehicle_type = vehicleData.tipo;
    }

    console.log('Complete shipment data with driver phone:', driverPhoneNumber);
    setCompleteShipmentData(shipmentData);
  } catch (error) {
    console.error('Error fetching complete shipment data:', error);
  }
};

  const handleCloseActionsModal = () => {
    setSelectedShipmentForSetting(null);
    setActionsModalOpen(false);
    setCompleteShipmentData(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isActionsModalOpen && !event.target.closest('.actions-modal') && !event.target.closest('.actions-button')) {
        handleCloseActionsModal();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isActionsModalOpen]);

  const handleOpenSettingModalFromActions = (shipment) => {
    handleCloseActionsModal();
    handleOpenSettingModal(shipment);
  };

  const handleOpenAdditionalCostsModal = (shipment) => {
    setSelectedShipmentForCosts(shipment);
    setAdditionalCostsModalOpen(true);
  };

  const handleCloseAdditionalCostsModal = () => {
    setAdditionalCostsModalOpen(false);
    setSelectedShipmentForCosts(null);
  };  const [filter, setFilter] = useState({
    reference: '',
    pickupDateRange: [null, null],
    deliveryDateRange: [null, null],
    customer: '',
    vendors: [],
    statuses: [],
    substatuses: [],
    returnStatus: '',
    operators: [],
    units: [],
    lts: [],
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value
    }));
  };
  
  const normalizeDate = (date) => {
    if (!date) return null;
    const normalizedDate = new Date(date);
    return new Date(normalizedDate.getFullYear(), normalizedDate.getMonth(), normalizedDate.getDate());
  };

  const isSameDay = (date1, date2) => {
    if (!date1 || !date2) return false;
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  };

  const handlePickupDateRangeChange = (dates) => {
    const [start, end] = dates;
    setFilter((prev) => ({
      ...prev,
      pickupDateRange: [start, end]
    }));
  };

  const handleDeliveryDateRangeChange = (dates) => {
    const [start, end] = dates;
    setFilter((prev) => ({
      ...prev,
      deliveryDateRange: [start, end]
    }));
  };

  const isDateInRange = (dateString, startDate, endDate) => {
    if (!dateString) return false;
    
    const dateParts = dateString.split('T')[0].split('-');
    if (dateParts.length !== 3) return false;
    
    const date = new Date(
      parseInt(dateParts[0]), 
      parseInt(dateParts[1]) - 1,
      parseInt(dateParts[2])
    );
    date.setHours(0, 0, 0, 0);
    
    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);
    
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);
    
    return date >= start && date <= end;
  };

  const isDateInRangeOld = (date, startDate, endDate) => {
    if (!date) return false;
    
    const normalizedDate = normalizeDate(date);
    const normalizedStartDate = normalizeDate(startDate);
    const normalizedEndDate = normalizeDate(endDate);
    
    if (isSameDay(normalizedStartDate, normalizedEndDate)) {
      return isSameDay(normalizedDate, normalizedStartDate);
    }
    
    return (
      normalizedDate >= normalizedStartDate && 
      normalizedDate <= normalizedEndDate
    );
  };

  const filteredShipments = shipments.filter((shipment) => {
    const matchesReference = !filter.reference || 
      (shipment.reference?.toLowerCase().includes(filter.reference.toLowerCase()) ?? false);
    
    const matchesCustomer = !filter.customer || 
      (shipment.customer?.toLowerCase().includes(filter.customer.toLowerCase()) ?? false);
      
    const matchesVendor = filter.vendors.length === 0 || 
      filter.vendors.includes(shipment.vendor);
    
    let matchesPickupDate = true;
    if (filter.pickupDateRange[0] && filter.pickupDateRange[1]) {
      matchesPickupDate = isDateInRangeOld(
        shipment.pickup_date, 
        filter.pickupDateRange[0], 
        filter.pickupDateRange[1]
      );
    }

    let matchesDeliveryDate = true;
    if (filter.deliveryDateRange[0] && filter.deliveryDateRange[1]) {
      if (!shipment.orders || shipment.orders.length === 0) {
        matchesDeliveryDate = false;
      } else {
        matchesDeliveryDate = shipment.orders.some(order => {
          return order.Appointment && isDateInRange(
            order.Appointment,
            filter.deliveryDateRange[0],
            filter.deliveryDateRange[1]
          );
        });
      }
    }    const matchesStatus = filter.statuses.length === 0 || 
      filter.statuses.includes(shipment.status);
      const matchesSubstatus = filter.substatuses.length === 0 || 
      filter.substatuses.includes(shipment.Substatus) || 
      (filter.substatuses.includes('N/A') && !shipment.Substatus);

    const matchesReturnStatus = !filter.returnStatus || 
      shipment.orders?.some(order => order.dev_status?.toLowerCase() === filter.returnStatus.toLowerCase());    const matchesOperator = filter.operators.length === 0 || 
      (shipment.driver && shipment.driver !== "undefined undefined" && filter.operators.includes(shipment.driver));
    const matchesUnit = filter.units.length === 0 || 
      (shipment.vehicle && filter.units.includes(shipment.vehicle));
    const matchesLt = filter.lts.length === 0 || 
      (shipment.Lt && filter.lts.includes(shipment.Lt));

    return matchesReference && matchesCustomer && matchesVendor && matchesPickupDate && matchesDeliveryDate && matchesStatus && matchesSubstatus && matchesReturnStatus && matchesOperator && matchesUnit && matchesLt;
  });

  // Calculate stats after filteredShipments is defined
  const stats = {
    totalShipments: filteredShipments.length,
    inTransit: filteredShipments.filter((s) => s.status === 'TRANSITO').length,
    delivered: filteredShipments.filter((s) => s.status === 'FINALIZADO').length,
    pending: filteredShipments.filter((s) => ['PENDIENTE', 'CREADO'].includes(s.status)).length,
    asign: filteredShipments.filter((s) => s.status === 'ASIGNADO').length,
    client: filteredShipments.filter((s) => s.status === 'EN CLIENTE').length,
    arrived: filteredShipments.filter((s) => s.status === 'ARRIBADO').length,
  };

  // Lógica de paginación
  const totalItems = filteredShipments.length;
  const totalPages = Math.ceil(totalItems / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedShipments = filteredShipments.slice(startIndex, endIndex);

  // Funciones para manejar la paginación
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1); // Reset to first page when changing rows per page
  };

  // Reset current page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [filter]);

  useEffect(() => {
    const fetchWarehouse = async () => {
      try {
        const warehouseData = await getWarehouses();
        setWarehouseData(warehouseData);
      } catch (error) {
        console.error('Error fetching Warehouse:', error);
      }
    };
    fetchWarehouse();
  }, []);

  useEffect(() => {
    const fetchAccountInfo = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setAccountName(response.data.name);
        setAccountRole(response.data.role);
      } catch (error) {
        console.error('Error al obtener la información de la cuenta:', error);
      }
    };

    fetchAccountInfo();
  }, []);

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const vendors = await getVendors();
        setVendorData(vendors);
      } catch (error) {
        console.error('Error fetching vendor data:', error);
      }
    };
    fetchVendors();
  }, []);
  // El filtro de clientes ahora usa Autocomplete directamente en onChange
  const handleStatusesChange = (event) => {
    const {
      target: { value },
    } = event;
    
    let newStatuses = [];
    
    if (value.includes('all')) {
      const uniqueStatuses = [...new Set(shipments.map(shipment => shipment.status))];
      if (filter.statuses.length !== uniqueStatuses.length) {
        newStatuses = uniqueStatuses;
        setFilter(prev => ({
          ...prev,
          statuses: newStatuses
        }));
      } else {
        setFilter(prev => ({
          ...prev,
          statuses: [],
          substatuses: [] // Reset substatuses when clearing all statuses
        }));
        setAvailableSubstatuses([]);
        return;
      }
    } 
    else {
      newStatuses = typeof value === 'string' ? value.split(',') : value;
      setFilter(prev => ({
        ...prev,
        statuses: newStatuses,
        substatuses: [] // Reset substatuses on status change
      }));
    }
    
    // Update available substatuses based on selected statuses
    updateAvailableSubstatuses(newStatuses);
  };
    // Function to update available substatuses based on selected statuses
  const updateAvailableSubstatuses = (selectedStatuses) => {
    if (selectedStatuses.length === 0) {
      setAvailableSubstatuses([]);
      return;
    }
    
    // Filter shipments with selected statuses
    const shipments = originalShipments.filter(s => selectedStatuses.includes(s.status));
    
    // Get unique substatuses from filtered shipments
    const substatuses = shipments.map(s => s.Substatus || 'N/A');
    const uniqueSubstatuses = [...new Set(substatuses)].sort((a, b) => {
      // Siempre poner N/A al final de la lista
      if (a === 'N/A') return 1;
      if (b === 'N/A') return -1;
      return a.localeCompare(b);
    });
    
    setAvailableSubstatuses(uniqueSubstatuses);
  };
    // Handle substatuses filter changes
  const handleSubstatusesChange = (event) => {
    const {
      target: { value },
    } = event;
    
    if (value.includes('all')) {
      if (filter.substatuses.length !== availableSubstatuses.length) {
        setFilter(prev => ({
          ...prev,
          substatuses: [...availableSubstatuses]
        }));
      } else {
        setFilter(prev => ({
          ...prev,
          substatuses: []
        }));
      }
    } 
    else {
      setFilter(prev => ({
        ...prev,
        substatuses: typeof value === 'string' ? value.split(',') : value
      }));
    }
  };  // Los filtros avanzados ahora usan Autocomplete directamente en onChange
  useEffect(() => {
    // Update available substatuses when filter.statuses changes
    if (filter.statuses.length > 0) {
      updateAvailableSubstatuses(filter.statuses);
    } else {
      setAvailableSubstatuses([]);
    }
  }, [filter.statuses, shipments]);
  
  useEffect(() => {
    if (originalShipments.length > 0) {
      const mideaShipments = originalShipments.filter(s => s.vendor === 'MIDEA MEXICO');
      //console.log('Embarques de MIDEA MEXICO encontrados:', mideaShipments.length);
      if (mideaShipments.length > 0) {
        //console.log('Ejemplo de embarque MIDEA:', mideaShipments[0]);
      } else {
        //console.log('No hay embarques con vendor="MIDEA MEXICO"');
        const vendorValues = [...new Set(originalShipments.map(s => s.vendor))];
        //console.log('Valores únicos de vendor en los embarques:', vendorValues);
        
        const possibleMideaValues = vendorValues.filter(v => 
          v && v.toLowerCase().includes('midea'));
        //console.log('Posibles valores para MIDEA:', possibleMideaValues);
      }
      
      if (vendorData.length > 0) {
        const mideaVendor = vendorData.find(v => v.nombre === 'MIDEA MEXICO');
        //console.log('Cuenta MIDEA encontrada en vendorData:', mideaVendor);
      }
    }
  }, [originalShipments, vendorData]);

  const getCompleteShipmentData = async (shipment) => {
    try {
      const shipmentData = await getShipmentWithOrdersProducts(shipment.id);
      return shipmentData;
    } catch (error) {
      console.error('Error fetching complete shipment data:', error);
      return null;
    }
  };

  const PDFButton = ({ shipment }) => {
    const [showNotifyDialog, setShowNotifyDialog] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [notificationStatus, setNotificationStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [smsMessage, setSmsMessage] = useState('');
    const [transporterPhone, setTransporterPhone] = useState('');

    useEffect(() => {
      if (showNotifyDialog && completeShipmentData && shipment.Lt) {
        const fetchTransporterPhone = async () => {
          try {
            const transportLines = await getTransportLines();
            const selectedLt = transportLines.find(lt => lt.name === shipment.Lt);
            
            if (selectedLt && selectedLt.telefono) {
              setTransporterPhone(selectedLt.telefono);
              
              const defaultSmsMessage = 
                `AMERISA: Embarque ${shipment.reference} asignado. ` +
                `${shipment.origin || 'N/A'} - ` +
                `${shipment.destination || 'N/A'}. ` +
                `Fecha carga: ${shipment.pickup_date ? formatDate(shipment.pickup_date) : 'Por definir'}.`;
              
              setSmsMessage(defaultSmsMessage);
            }
          } catch (error) {
            console.error('Error al obtener teléfono del transportista:', error);
          }
        };
        
        fetchTransporterPhone();
      }
    }, [showNotifyDialog, completeShipmentData, shipment]);

    const handleSendNotification = async () => {
      if (!shipment.Lt) {
        setErrorMessage('Debe asignar una línea de transporte antes de enviar las notificaciones.');
        setNotificationStatus('error');
        return;
      }

      setIsLoading(true);
      setNotificationStatus(null);
      
      let emailSuccess = false;
      let smsSuccess = false;
      let errorMsg = '';

      try {
        const pdfBlob = await pdf(
          <InstructionLetterPDF 
            shipmentData={[completeShipmentData]} 
            accountName={accountName} 
            accountRole={accountRole} 
            warehouseData={warehouseData}
            vehicleInfo={shipmentVehicleData.vehicle}
            trailerInfo={shipmentTrailerData}
          />
        ).toBlob();

        if (completeShipmentData.transporterEmail) {
          const recipientEmail = completeShipmentData.transporterEmail;

          const messageBody = `
            <div style="font-family: Arial, sans-serif; color: #333;">
              <p>Estimado transportista,</p>
              <p>Le hacemos envío de la carta de instrucción para el embarque con referencia <strong>${shipment.reference}</strong>.</p>
              <p><strong>INFORMACIÓN DEL EMBARQUE:</strong></p>
              <ul>
                <li><strong>Referencia:</strong> ${shipment.reference}</li>
                <li><strong>Cliente:</strong> ${shipment.vendor || 'N/A'}</li>
              </ul>
              <p><strong>DATOS DE CARGA:</strong></p>
              <ul>
                <li><strong>Origen:</strong> ${shipment.origin || 'N/A'}</li>
                <li><strong>Fecha de carga:</strong> ${shipment.pickup_date ? formatDate(shipment.pickup_date) : 'Por definir'}</li>
              </ul>
              <p><strong>DATOS DE ENTREGA:</strong></p>
              <ul>
                ${shipment.customer ? `<li><strong>Consignatario:</strong> ${shipment.customer}</li>` : ''}
                ${shipment.orders && shipment.orders.length > 0 ? `
                  <li><strong>Número de paradas:</strong> ${new Set(shipment.orders.map(o => o.Stop)).size}</li>
                  ${shipment.orders.map(order => `
                    <li>Parada ${order.Stop}: ${order.City || 'N/A'}, ${order.State || 'N/A'}</li>
                  `).join('')}
                ` : '<li>Sin órdenes asignadas</li>'}
              </ul>
              <p><strong>DATOS DE TRANSPORTE:</strong></p>
              <ul>
                <li><strong>Línea transportista:</strong> ${shipment.Lt || 'N/A'}</li>
                <li><strong>Conductor:</strong> ${shipment.driver || 'N/A'}</li>
                <li><strong>Teléfono del conductor:</strong> ${completeShipmentData.driver_phone || 'No disponible'}</li>
                <li><strong>Vehículo:</strong> ${shipment.vehicle || 'N/A'}</li>
              </ul>
              <p><strong>REQUISITOS ESPECIALES:</strong></p>
              <p>${shipment.requerimientos || 'No se especifican requisitos especiales.'}</p>
              <p>Por favor, revise detalladamente la carta de instrucciones adjunta y confirme su recepción.</p>
              <p>Para cualquier duda o aclaración, contáctenos a los teléfonos que aparecen en la carta.</p>
            </div>
          `;

          const formData = new FormData();
          formData.append('recipientEmail', recipientEmail);
          formData.append('recipientName', 'Transportista');
          formData.append('subject', `Carta de Instrucción - Embarque ${shipment.reference}`);
          formData.append('message', messageBody);
          formData.append('attachment', pdfBlob, `ControlVehicular_${shipment.reference}.pdf`);
          
          // Obtener información del usuario actual, con console.log para depuración
          console.log("Datos del remitente que se enviarán:");
          console.log("Nombre:", accountName);
          console.log("Cargo:", accountRole);
          
          // Obtener perfil del usuario desde la API si está disponible
          let userProfile = {};
          try {
            const userData = await getUserProfile();
            userProfile = userData;
          } catch (error) {
            console.error("Error al recuperar perfil de usuario:", error);
            // Intentar recuperar desde localStorage como respaldo
            userProfile = localStorage.getItem('userProfile') 
              ? JSON.parse(localStorage.getItem('userProfile')) 
              : {};
          }
            // Agregar datos del remitente con valores definitivos (sin fallbacks)
          formData.append('senderName', accountName);
          formData.append('senderPosition', accountRole);
          formData.append('senderPhone', userProfile.phone || accountName.includes("Miguel") ? "(999) 316-3999" : "(999) 316-3999");
          formData.append('senderMobile', userProfile.mobile || accountName.includes("Miguel") ? "(999) 141-9748" : "(55) 2109-7185");
          formData.append('senderEmail', userProfile.email || "logistica@amerisa.com.mx");
          
          // Buscar el ID de la línea de transporte
          const transportLines = await getTransportLines();
          const selectedLt = transportLines.find(lt => lt.name === shipment.Lt);
          if (selectedLt && selectedLt.id) {
            // Agregar el ID de la línea de transporte a la solicitud
            formData.append('id_linea_transporte', selectedLt.id);
          }

          try {
            await notifyTransporter(shipment.id, formData);
            emailSuccess = true;
          } catch (emailError) {
            console.error('Error al enviar email:', emailError);
            errorMsg += 'Error al enviar el correo electrónico. ';
          }        } else {
          errorMsg += 'No se pudo enviar el correo: falta dirección de email. ';
        }

        if (transporterPhone) {
          try {
            await notifyTransporterSMS(shipment.id, {
              phone: transporterPhone,
              message: smsMessage
            });
            smsSuccess = true;
          } catch (smsError) {
            console.error('Error al enviar SMS:', smsError);
            errorMsg += 'Error al enviar el SMS. ';
          }
        } else {
          errorMsg += 'No se pudo enviar el SMS: falta número telefónico. ';
        }

        if (emailSuccess || smsSuccess) {
          setNotificationStatus('success');
          
          setTimeout(() => {
            setShowNotifyDialog(false);
            setNotificationStatus(null);
          }, 2000);
        } else {
          setNotificationStatus('error');
          setErrorMessage(errorMsg || 'Error al enviar notificaciones.');
        }

      } catch (error) {
        console.error('Error en el proceso de notificación:', error);
        setNotificationStatus('error');
        setErrorMessage('Error al preparar las notificaciones. Intente nuevamente.');
      } finally {
        setIsLoading(false);
      }
    };

    if (!completeShipmentData) {
      return (
        <Button
          className="w-full text-center p-2 hover:bg-gray-100"
          disabled={true}
          title="Cargando datos..."
        >
          <ClipboardPen className="mx-auto" />
        </Button>
      );
    }

    const shipmentVehicleData = vehicleData[shipment.id] || {};
    const shipmentTrailerData = trailerData[shipment.id] || [];
    
    const transporterEmail = completeShipmentData.transporterEmail || 'No disponible';
    const contactInfo = `Email: ${transporterEmail} | Teléfono: ${transporterPhone || 'No disponible'}`;

    const NotifyDialog = () => (
      <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
        <div className="bg-white rounded-xl p-8 w-full max-w-xl shadow-2xl transform transition-all">
          <div className="flex justify-center mb-4">
            <div className="bg-sky-100 p-4 rounded-full">
              <ClipboardPen size={36} className="text-sky-600" />
            </div>
          </div>
          
          <h2 className="text-2xl font-bold mb-3 text-center text-gray-800">Carta de Instrucciones</h2>
          
          {notificationStatus === 'success' ? (
            <div className="flex flex-col items-center justify-center py-6">
              <div className="bg-green-100 p-3 rounded-full mb-4">
                <svg className="h-12 w-12 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <p className="text-lg font-medium text-green-700">¡Notificaciones enviadas con éxito!</p>
              <p className="text-gray-500 mt-1">El transportista ha sido notificado por los medios disponibles.</p>
            </div>
          ) : notificationStatus === 'error' ? (
            <div className="flex flex-col items-center justify-center py-6">
              <div className="bg-red-100 p-3 rounded-full mb-4">
                <svg className="h-12 w-12 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
              <p className="text-lg font-medium text-red-700">Error al enviar notificación</p>
              <p className="text-gray-500 mt-1">{errorMessage}</p>
              <button 
                className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                onClick={() => setNotificationStatus(null)}
              >
                Intentar nuevamente
              </button>
            </div>
          ) : (
            <>
              <p className="mb-4 text-center text-gray-600 text-base">
                Esta carta contiene información importante sobre el embarque. Envíela al transportista.
              </p>
              
              <div className="mb-6 p-4 bg-gray-100 rounded-lg">
                <h3 className="font-semibold mb-2 text-gray-700">Datos del transportista:</h3>
                <div className="space-y-1">
                  <p className="flex items-center text-sm">
                    <svg className="w-4 h-4 mr-2 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <span>{completeShipmentData.transporterEmail || 'No disponible'}</span>
                  </p>
                  <p className="flex items-center text-sm">
                    <svg className="w-4 h-4 mr-2 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l 1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.27-1.27a1  1 0 01 2.11-.45l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                    </svg>
                    <span>{transporterPhone || 'No disponible'}</span>
                  </p>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4 mt-8">
                <PDFDownloadLink
                  document={
                    <InstructionLetterPDF 
                      shipmentData={[completeShipmentData]} 
                      accountName={accountName} 
                      accountRole={accountRole} 
                      warehouseData={warehouseData}
                      vehicleInfo={shipmentVehicleData.vehicle}
                      trailerInfo={shipmentTrailerData}
                    />
                                   }
                  fileName={`ControlVehicular_${shipment.reference}.pdf`}
                  className="flex items-center justify-center px-6 py-3 border border-gray-300 rounded-lg bg-white text-gray-700 hover:bg-gray-100 transition-colors shadow-sm font-medium"
                >
                  {({ loading }) => (
                    <>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                      </svg>
                      {loading ? "Preparando..." : "Solo descargar"}
                    </>
                  )}
                </PDFDownloadLink>
                
                <button 
                  className="flex items-center justify-center px-6 py-3 bg-sky-600 text-white rounded-lg hover:bg-sky-700 transition-colors shadow-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleSendNotification}
                  disabled={isLoading || (!completeShipmentData.transporterEmail && !transporterPhone)}
                  title={(!completeShipmentData.transporterEmail && !transporterPhone) 
                    ? "No hay datos de contacto disponibles para el transportista" 
                    : "Enviar notificación por email y SMS"}
               
                >
                  {isLoading ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Enviando...
                    </>
                  ) : (
                    <>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18-9-2zm0 0v-8" />
                      </svg>
                      Notificar
                    </>
                  )}
                </button>
              </div>
            </>
          )}
          
          <button 
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors"
            onClick={() => setShowNotifyDialog(false)}
            aria-label="Cerrar"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>          </button>
        </div>
      </div>
    );

    return (
      <>
        <Button
          className="w-full text-center p-2 hover:bg-gray-100"
          onClick={() => setShowNotifyDialog(true)}
          title={//contactInfo} // comentada para que muestre el texto en vez de la informacion de destino de la CI
            `Carta de instrucciones`}
        >
          <ClipboardPen className="mx-auto" />
        </Button>
        
        <div className="hidden">
          <PDFDownloadLink
            document={
              <InstructionLetterPDF 
                shipmentData={[completeShipmentData]} 
                accountName={accountName} 
                accountRole={accountRole} 
                warehouseData={warehouseData}
                vehicleInfo={shipmentVehicleData.vehicle}
                trailerInfo={shipmentTrailerData}
              />
            }
            fileName={`ControlVehicular_${shipment.reference}.pdf`}
            data-shipment-id={shipment.id}
          >
            {() => ""}
          </PDFDownloadLink>
        </div>
        
        {showNotifyDialog && <NotifyDialog />}
      </>
    );
  };

  const handleOpenStatusModal = async (shipment) => {
    console.log("Abriendo modal para el embarque:", shipment);
    
    try {
      const shipmentData = await getShipmentWithOrders(shipment.id);
      console.log("Datos completos del embarque:", shipmentData);
      
      setSelectedShipmentRef(shipmentData);
      setStatusModalOpen(true);
    } catch (error) {
      console.error("Error al obtener datos del embarque:", error);
      setSelectedShipmentRef(shipment);
      setStatusModalOpen(true);
    }
  };

  const handleOpenEntregaModal = async (shipment) => {
    console.log("Abriendo modal de entrega para el embarque:", shipment);
    
    try {
      const shipmentData = await getShipmentWithOrders(shipment.id);
      console.log("Datos completos del embarque para entrega:", shipmentData);
      
      setSelectedShipmentRef(shipmentData);
      setReferencia(shipment.reference);
      setEntregaModalOpen(true);
    } catch (error) {
      console.error("Error al obtener datos del embarque para entrega:", error);
      setSelectedShipmentRef(shipment);
      setEntregaModalOpen(true);
    }
  };

  const getFormattedDateTime = (order) => {
    if (!order) return 'Sin fecha';
    return `${order.Appointment || ''} ${order.Appointment_hr || ''}`.trim() || 'Sin fecha';
  };

  const ShipmentRow = ({ shipment, actions, formatDate, getStatusBadge, getDevStatusDotColor, getFormattedDateTime, toggleShipmentExpand, warehouseData, handlePutOnHold, handleRemoveFromHold }) => {
    const [driverPhone, setDriverPhone] = useState(null);
    const isOpen = expandedShipments[shipment.id] || false;
    
    useEffect(() => {
      const fetchDriverPhone = async () => {
        if (isOpen && shipment.Lt && shipment.driver && shipment.driver !== "undefined undefined") {
          try {
            const transportLines = await getTransportLines();
            const selectedLt = transportLines.find(lt => lt.name === shipment.Lt);
            
            if (selectedLt) {
              const drivers = await getDriversByLine(selectedLt.id);
              console.log('Fetched drivers:', drivers);
              console.log('Looking for driver:', shipment.driver);
              
              // Try multiple ways to match driver name
              let driverInfo = drivers.find(d => {
                // Create potential name formats
                const fullName = `${d.nombre} ${d.apellido_paterno}`.trim();
                const fullNameWithMaterno = `${d.nombre} ${d.apellido_paterno} ${d.apellido_materno || ''}`.trim();
                const nameReverseFormat = `${d.apellido_paterno} ${d.nombre}`.trim();
                
                // Try different formats for matching
                return shipment.driver === fullName || 
                       shipment.driver === fullNameWithMaterno ||
                       shipment.driver === nameReverseFormat;
              });
              
              // If still not found, try a more flexible matching
              if (!driverInfo) {
                driverInfo = drivers.find(d => 
                  shipment.driver.includes(d.nombre) && 
                  (d.apellido_paterno ? shipment.driver.includes(d.apellido_paterno) : true)
                );
              }
              
              if (driverInfo && driverInfo.telefono) {
                console.log('Found driver phone:', driverInfo.telefono);
                setDriverPhone(driverInfo.telefono);
              } else {
                console.log('No matching driver found with phone number');
              }
            }
          } catch (error) {
            console.error('Error al obtener teléfono del conductor:', error);
          }
        }
      };
      
      fetchDriverPhone();
    }, [isOpen, shipment.Lt, shipment.driver]);

    const getOrderCustomerName = (order) => {
      if (order.customer) return order.customer;
      if (order.Customer) return order.Customer;
      if (order.customerName) return order.customerName;
      if (order.customer_name) return order.customer_name;
      
      if (order.consignee) return order.consignee;
      if (order.Consignee) return order.Consignee;
      
      return 'N/A';
    };

    const sortedOrders = React.useMemo(() => {
      if (!shipment.orders || shipment.orders.length === 0) return [];
      return [...shipment.orders].sort((a, b) => {
        const stopA = a.Stop || Number.MAX_SAFE_INTEGER;
        const stopB = b.Stop || Number.MAX_SAFE_INTEGER;
        return stopA - stopB;
      });
    }, [shipment.orders]);

    const getDestinationCity = (order) => {
      if (!order || !order.D_R) {
        return order?.City || 'N/A';
      }
      
      if (warehouseData && warehouseData.length > 0) {
        const warehouse = warehouseData.find(
          w => w.nombre === order.customer || w.nombre === order.Customer
        );
        
        if (warehouse && warehouse.ciudad_municipio) {
          return warehouse.ciudad_municipio;
        }
      }
      
      return order.City || 'N/A';
    };

    return (
      <>
        <TableRow 
          className={`hover:bg-gray-50 ${
            shipment.status === 'RESGUARDO' ? 'row-breathing' : ''
          } ${
            shipment.orders?.some(order => order.substatus_reentrega && order.substatus_reentrega.trim() !== '') 
              ? 'bg-yellow-100' 
              : ''
          }`}
        >
          <TableCell className="px-2 py-2">
            <div 
              className="cursor-pointer flex items-center justify-center"
              onClick={() => toggleShipmentExpand(shipment.id)}
            >
              {isOpen ? (
                <ChevronDown className="h-5 w-5 text-gray-500" />
              ) : (
                <ChevronRight className="h-5 w-5 text-gray-500" />
              )}
            </div>
          </TableCell>
          <TableCell className="px-4 py-2">{shipment.reference || 'N/A'}</TableCell>
          <TableCell className="px-4 py-2">{shipment.Truck || 'N/A'}</TableCell>
          <TableCell className="px-4 py-2">{shipment.customer || 'N/A'}</TableCell>
          <TableCell className="px-4 py-2">
            {sortedOrders.length > 0 ? (
              <div className="space-y-1">
                {sortedOrders.map((order) => (
                  <div key={order.id} className="text-sm text-gray-700">
                    {order.Order_number}
                  </div>
                ))}
              </div>
            ) : (
              <span className="text-sm text-gray-700">Sin órdenes</span>
            )}
          </TableCell>
          <TableCell className="px-4 py-2">
            {sortedOrders.length > 0 ? (
              <div className="space-y-1">
                {(() => {
                  const uniqueCities = [];
                  const seenCities = new Set();
                  
                  sortedOrders.forEach(order => {
                    const city = getDestinationCity(order);
                    if (!seenCities.has(city)) {
                      uniqueCities.push(city);
                      seenCities.add(city);
                    }
                  });
                  
                  return uniqueCities.map((city, index) => (
                    <div key={index} className="text-sm text-gray-700">
                      {city}
                    </div>
                  ));
                })()}
              </div>
            ) : (
              <span className="text-sm text-gray-700">Sin destino</span>
            )}
          </TableCell>
          <TableCell className="px-4 py-2">{shipment.Lt || 'N/A'}</TableCell>
          <TableCell className="px-4 py-2">{shipment.vehicle || 'N/A'}</TableCell>
          <TableCell className="px-4 py-2">
            {(shipment.driver === "undefined undefined" || !shipment.driver) ? 'N/A' : shipment.driver}
          </TableCell>
          <TableCell className="px-4 py-2">{getStatusBadge(shipment.status || 'PENDIENTE')}</TableCell>
          <TableCell className="px-4 py-2">
            {shipment.Substatus || 'N/A'}
            {shipment.orders?.some(order => order.substatus_reentrega && order.substatus_reentrega.trim() !== '') && (
              <div className="text-sm text-gray-700">
                <span>Reentrega: </span>
                {shipment.orders
                  .filter(order => order.substatus_reentrega && order.substatus_reentrega.trim() !== '')
                  .map((order, index) => (
                    <span key={index}>{order.substatus_reentrega}</span>
                  ))}
              </div>
            )}
          </TableCell>
          <TableCell className="px-4 py-2">
            {shipment.pickup_date ? formatDate(shipment.pickup_date) : 'Sin fecha'}
          </TableCell>
          <TableCell className="px-4 py-2">
            {sortedOrders.length > 0 ? (
              <div className="space-y-1">
                {(() => {
                  const groupedOrders = sortedOrders.reduce((acc, order) => {
                    if (!acc[order.Stop]) acc[order.Stop] = [];
                    acc[order.Stop].push(order);
                    return acc;
                  }, {});
                  
                  const entries = Object.entries(groupedOrders).sort((a, b) => {
                    const stopA = a[0] ? parseInt(a[0]) : Number.MAX_SAFE_INTEGER;
                    const stopB = b[0] ? parseInt(b[0]) : Number.MAX_SAFE_INTEGER;
                    return stopA - stopB;
                  });
                  
                  return entries.length === 1 ? (
                    <div className="px4-py2">
                      {formatDate(getFormattedDateTime(entries[0][1][0]))}
                    </div>
                  ) : (
                    entries.map(([stop, orders]) => (
                      <div key={stop} className="text-sm text-gray-700">
                        • Parada {stop}: {formatDate(getFormattedDateTime(orders[0]))}
                      </div>
                    ))
                  );
                })()}
              </div>
            ) : (
              'Sin fecha'
            )}
          </TableCell>
          <TableCell className="px-4 py-2 text-center">
            <div className="flex justify-center items-center">
              <div className={`w-4 h-4 rounded-full ${getDevStatusDotColor(shipment.orders)}`}></div>
            </div>
          </TableCell>
          <TableCell className="px-4 py-2" onClick={(e) => e.stopPropagation()}>
            {actions(shipment)}
          </TableCell>
        </TableRow>

        {isOpen && (
          <tr className="accordion-row bg-white">
            <td colSpan="15" className="p-0 border-0">
              <div className="w-full bg-white border-t border-gray-200 shadow-inner p-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-gray-50 p-4 rounded-lg shadow space-y-3">
                    <h3 className="font-semibold text-lg border-b pb-2 text-gray-700">Detalles del Embarque</h3>
                    <div className="flex items-center">
                      <Truck className="h-5 w-5 mr-2 text-gray-600" />
                      <span><strong>Referencia:</strong> {shipment.reference || 'N/A'}</span>
                    </div>
                    <div className="flex items-center">
                      <Briefcase className="h-5 w-5 mr-2 text-gray-600" />
                      <span><strong>Cliente:</strong> {shipment.vendor || 'N/A'}</span>
                    </div>
                    <div className="flex items-center">
                      <MapPin className="h-5 w-5 mr-2 text-gray-600" />
                      <span><strong>Origen:</strong> {shipment.origin || 'N/A'}</span>
                    </div>
                    <div className="flex items-center">
                      <Calendar className="h-5 w-5 mr-2 text-gray-600" />
                      <span><strong>Fecha Carga:</strong> {shipment.pickup_date ? formatDate(shipment.pickup_date) : 'Sin fecha'}</span>
                    </div>
                    {/* Botón para poner en resguardo solo si el estado es TRANSITO */}
                    {shipment.status === 'TRANSITO' && (
                      <Button
                        className="mt-4 bg-yellow-600 text-white hover:bg-yellow-700"
                        onClick={() => handlePutOnHold(shipment)}
                      >
                        Poner en resguardo
                      </Button>
                    )}
                    {shipment.status === 'RESGUARDO' && (
                      <Button
                        className="mt-4 bg-green-600 text-white hover:bg-green-700"
                        onClick={() => handleRemoveFromHold(shipment)}
                      >
                        Retirar de resguardo
                      </Button>
                    )}
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg shadow">
                    <h3 className="font-semibold text-lg border-b pb-2 text-gray-700">Órdenes ({sortedOrders.length || 0})</h3>
                    <div className="mt-2 max-h-40 overflow-y-auto">
                      {sortedOrders.length > 0 ? (
                        <ul className="space-y-2">
                          {sortedOrders.map((order) => (
                            <li key={order.id} className="border-b pb-1">
                              <div className="flex justify-between">
                                <span className="font-medium">{order.Order_number}</span>
                                <Badge variant="outline">{order.Order_status || 'N/A'}</Badge>
                              </div>
                              <div className="text-sm text-gray-600">
                                Cliente: {getOrderCustomerName(order)}
                              </div>
                              <div className="text-sm text-gray-600">
                                Ciudad: {getDestinationCity(order)}
                              </div>
                              <div className="text-sm text-gray-600">
                                Parada: {order.Stop || 'N/A'}
                              </div>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="text-gray-500 italic">Sin órdenes asignadas</p>
                      )}
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg shadow space-y-3">
                    <h3 className="font-semibold text-lg border-b pb-2 text-gray-700">Transporte</h3>
                    <div className="flex items-center">
                      <User className="h-5 w-5 mr-2 text-gray-600" />
                      <span><strong>Conductor:</strong> {(shipment.driver === "undefined undefined" || !shipment.driver) ? 'N/A' : shipment.driver}</span>
                    </div>
                    
                    <div className="flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5 mr-2 text-gray-600">
                        <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                      <span>
                        <strong>Teléfono:</strong> {driverPhone ? driverPhone : (
                          shipment.driver && shipment.driver !== "undefined undefined" ? 
                          <span className="text-gray-500 italic">Cargando...</span> : 'N/A'
                        )}
                      </span>
                    </div>
                    
                    <div className="flex items-center">
                      <Truck className="h-5 w-5 mr-2 text-gray-600" />
                      <span><strong>Vehículo:</strong> {shipment.vehicle || 'N/A'}</span>
                    </div>
                    <div className="flex items-center">
                      <Briefcase className="h-5 w-5 mr-2 text-gray-600" />
                      <span><strong>Línea de Transporte:</strong> {shipment.Lt || 'N/A'}</span>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        )}
      </>
    );
  };

  const renderActions = (shipment) => (
    <div className="flex items-center space-x-2">
      <div className="relative">
        <Button
          className="hover:bg-gray-400 rounded-lg text-gray-800 actions-button"
          onClick={() => handleOpenActionsModal(shipment)}
        >
          <MoreVertical />
        </Button>
        {selectedShipmentForSetting && selectedShipmentForSetting.id === shipment.id && isActionsModalOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white border rounded shadow-lg z-10 actions-modal p-2 grid grid-cols-4 gap-1">
            <Button
              className={`w-full text-center p-2 hover:bg-gray-100 ${!['PENDIENTE', 'ARRIBADO'].includes(shipment.status) ? 'opacity-50 cursor-not-allowed' : ''}`}
              onClick={() => ['PENDIENTE', 'ARRIBADO'].includes(shipment.status) ? handleOpenSettingModalFromActions(shipment) : null}
              disabled={!['PENDIENTE', 'ARRIBADO'].includes(shipment.status)}
              title="Configurar Embarque"
            >
              <Truck className="mx-auto" />
            </Button>
            
            <PDFButton shipment={shipment} />

            <Button
              className="w-full text-center p-2 hover:bg-gray-100"
              onClick={() => handleOpenCommentsModal(shipment)}
              title="Historial de Comentarios"
            >
              <Circle className="mx-auto" />
            </Button>

            <Button
              className="w-full text-center p-2 hover:bg-gray-100"
              onClick={() => navigate(`/tracking?shipment=${shipment.reference}`)}
              title="Seguimiento"
            >
              <TrafficCone className="mx-auto" />
            </Button>

            <Button
              className="w-full text-center p-2 hover:bg-gray-100"
              onClick={() => handleOpenAdditionalCostsModal(shipment)}
              title="Costos Adicionales"
              >
              <RectangleEllipsis className="mx-auto" />
            </Button>

            <Button
              className={`w-full text-center p-2 hover:bg-gray-100 ${!(['PENDIENTE', 'ARRIBADO'].includes(shipment.status) || accountRole === 'admin') ? 'opacity-50 cursor-not-allowed' : ''}`}
              onClick={() => (['PENDIENTE', 'ARRIBADO'].includes(shipment.status) || accountRole === 'admin') ? handleOpenConfirmationModal(shipment) : null}
              disabled={!( ['PENDIENTE', 'ARRIBADO'].includes(shipment.status) || accountRole === 'admin')}
              title="Revertir Embarque"
            >
              <CircleArrowLeft className="mx-auto" />
            </Button>
            
            
            
            <Button
              className="w-full text-center p-2 hover:bg-gray-100"
              onClick={() => navigate(`/anticipos?shipment_reference=${shipment.reference}`)}
              title="Solicitar Anticipo"
            >
              <DollarSign className="mx-auto" />
            </Button>
            <Button
              className="w-full text-center p-2 hover:bg-gray-100"
              onClick={() => navigate(`/gas-vouchers?shipment_reference=${shipment.reference}`)}
              title="Vale de Combustible"
            >
              <Fuel className="mx-auto" />
            </Button>
          </div>
        )}
      </div>
      <Button
        className={`hover:bg-gray-400 rounded-lg text-gray-800 ${(!shipment.orders || shipment.orders.length === 0 || !shipment.driver || shipment.driver === "undefined undefined" || !shipment.vehicle || !['Trafico', 'admin', 'Multicuentas','Propios'].includes(accountRole)) ? 'opacity-50 cursor-not-allowed' : ''}`}
        onClick={() => {          const hasOrdersInRampa = shipment.orders && shipment.orders.some(order => 
            order.substatus_reentrega === 'DESCARGANDO'
          );
          
          if ((shipment.status === 'EN CLIENTE' && shipment.Substatus === 'DESCARGANDO') || hasOrdersInRampa) {
            if (shipment.orders && shipment.orders.length > 0 && 
                shipment.driver && shipment.driver !== "undefined undefined" && 
                shipment.vehicle && ['Trafico', 'admin', 'Multicuentas','Propios'].includes(accountRole)) {
              handleOpenEntregaModal(shipment);
            }
          } else {
            if (shipment.orders && shipment.orders.length > 0 && 
                shipment.driver && shipment.driver !== "undefined undefined" && 
                shipment.vehicle && ['Trafico', 'admin', 'Multicuentas','Propios'].includes(accountRole)) {
              handleOpenStatusModal(shipment);
            }
          }
        }}
        disabled={!shipment.orders || shipment.orders.length === 0 || 
                 !shipment.driver || shipment.driver === "undefined undefined" || 
                 !shipment.vehicle || !['Trafico', 'admin', 'Multicuentas','Propios'].includes(accountRole)}
        title={
          !shipment.orders || shipment.orders.length === 0 ? 'Falta asignar órdenes' : 
          !shipment.driver || shipment.driver === "undefined undefined" ? 'Falta asignar conductor' : 
          !shipment.vehicle ? 'Falta asignar vehículo' : 
          !['Trafico', 'admin', 'Multicuentas','Propios'].includes(accountRole) ? 'Solo usuarios autorizados pueden cambiar el estatus' :
          'Actualizar estatus'
        }
      >
        <StepForward />
      </Button>
      <Button
        className="hover:bg-gray-400 rounded-lg text-gray-800"
        onClick={() => handleOpenMiuimodal(shipment.id)}
        title="Eliminar Embarque"
      >
        <Trash />
      </Button>
    </div>
  );

  // Handler para poner en resguardo
  const handlePutOnHold = async (shipment) => {
    const userName = localStorage.getItem('userName') || 'Usuario';
    try {
      await putShipmentOnHold(shipment.id, userName);
      setSuccessMessage('Embarque puesto en resguardo correctamente.');
      fetchShipments();
    } catch (error) {
      setError('No se pudo poner en resguardo el embarque.');
    }
  };

  // Handler para retirar de resguardo
  const handleRemoveFromHold = async (shipment) => {
    const userName = localStorage.getItem('userName') || 'Usuario';
    try {
      await removeShipmentFromHold(shipment.id, userName);
      setSuccessMessage('Embarque retirado de resguardo correctamente.');
      fetchShipments();
    } catch (error) {
      setError('No se pudo retirar de resguardo el embarque.');
    }
  };

  return (
    <div className="flex">
      <Sidebar
        isOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        onLogout={handleLogout}
      />
      <div
        className={`transition-all duration-300 flex-1 ${
          sidebarOpen ? 'ml-64' : 'ml-16'
        } bg-gray-100 min-h-screen p-6 z-0 relative`} 
      >
        <Topbar 
           
          searchValue={searchValue}
          onSearchChange={(value) => {
            setSearchValue(value);
            setFilter(prev => ({ ...prev, reference: value }));
          }}
        />

        <div className="my-4">
          <Button
            onClick={() => setModalOpen(true)}
            className="p-2 bg-sky-700 text-white rounded-lg hover:bg-sky-800 flex items-center gap-2"
          >
            <Plus className="h-5 w-5" />
            <span className="font-medium">Crear Embarque</span>
          </Button>        </div>        {/* Sección de Filtros Mejorada */}
        <Card className="mb-4 shadow-sm border border-gray-200">          <CardHeader className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200 py-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 bg-sky-600 rounded-full"></div>
                <CardTitle className="text-base font-semibold text-gray-800">Filtros de Búsqueda</CardTitle>
              </div>
              <Button
                onClick={() => setFilter({
                  reference: '',
                  pickupDateRange: [null, null],
                  deliveryDateRange: [null, null],
                  customer: '',
                  vendors: [],
                  statuses: [],
                  substatuses: [],
                  returnStatus: '',
                  operators: [],
                  units: [],
                  lts: [],
                })}
                variant="outline"
                className="text-gray-600 border-gray-300 hover:bg-gray-50 text-xs py-1 px-3 h-7"
              >
                Limpiar Filtros
              </Button>
            </div>
          </CardHeader>
          <CardContent className="p-3">
            <Stack direction="row" spacing={1.5} sx={{ flexWrap: 'wrap', gap: 1.5, alignItems: 'flex-end' }}>          <FormControl sx={{ minWidth: 160 }} size="small">
            <TextField
              label="Referencia"
              name="reference"
              value={filter.reference}
              onChange={handleFilterChange}
              size="small"
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'white',
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#0ea5e9',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#0ea5e9',
                  },
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: '#0ea5e9',
                },
              }}
            />
          </FormControl>          <div className="filter-container" style={{ minWidth: 160 }}>
            <div style={{ height: '20px', marginBottom: '4px' }}>
              <label className="block text-sm font-medium text-gray-700">Fecha de Carga</label>
            </div>
            <div className="react-datepicker-wrapper">              <DatePicker
                selected={filter.pickupDateRange[0]}
                onChange={handlePickupDateRangeChange}
                startDate={filter.pickupDateRange[0]}
                endDate={filter.pickupDateRange[1]}
                selectsRange
                placeholderText="Seleccionar rango"
                className="p-2 border border-gray-300 rounded-md w-full bg-white text-sm focus:ring-1 focus:ring-sky-500 focus:border-sky-500 hover:border-sky-300 h-10"
                dateFormat="dd/MM/yyyy"
                usePopper={true}
                popperClassName="date-picker-popper"
                popperPlacement="bottom-start"
                withPortal={true}
              />
            </div>
          </div>          <div className="filter-container" style={{ minWidth: 160 }}>
            <label className="block text-xs font-medium text-gray-700 mb-1">Fecha de Entrega</label>
            <div className="react-datepicker-wrapper">              <DatePicker
                selected={filter.deliveryDateRange[0]}
                onChange={handleDeliveryDateRangeChange}
                startDate={filter.deliveryDateRange[0]}
                endDate={filter.deliveryDateRange[1]}
                selectsRange
                placeholderText="Seleccionar rango"
                className="p-2 border border-gray-300 rounded-md w-full bg-white text-sm focus:ring-1 focus:ring-sky-500 focus:border-sky-500 hover:border-sky-300 h-10"
                dateFormat="dd/MM/yyyy"
                usePopper={true}
                popperClassName="date-picker-popper"
                popperPlacement="bottom-start"
                withPortal={true}
              />
            </div>
          </div>          <FormControl sx={{ minWidth: 160 }} size="small">
            <TextField
              label="Consignatario"
              name="customer"
              value={filter.customer}
              onChange={handleFilterChange}
              size="small"
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'white',
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#0ea5e9',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#0ea5e9',
                  },
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: '#0ea5e9',
                },
              }}
            />
          </FormControl>            {/* Filtro de Clientes con Autocomplete */}
          <Autocomplete
            multiple
            size="small"
            id="vendor-autocomplete"
            options={vendorData.map(vendor => vendor.nombre).sort((a, b) => a.localeCompare(b))}
            value={filter.vendors}
            onChange={(event, newValue) => {
              setFilter(prev => ({
                ...prev,
                vendors: newValue
              }));
            }}
            disableCloseOnSelect
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </li>
            )}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Cliente(s)" 
                placeholder={filter.vendors.length === 0 ? "Todos los clientes" : "Buscar clientes..."} 
              />
            )}
            renderTags={(tagValue, getTagProps) =>
              tagValue.length > 1 ? (
                <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                  {tagValue.length} clientes seleccionados
                </span>
              ) : (
                tagValue.map((option, index) => (
                  <span key={index} style={{ fontSize: '0.875rem' }}>
                    {option}
                  </span>
                ))
              )
            }
            isOptionEqualToValue={(option, value) => option === value}
            sx={{
              width: 200,
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'white',
              },
              '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#0ea5e9',
              },
              '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#0ea5e9',
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: '#0ea5e9',
              },
            }}
          />
            <FormControl sx={{ width: 220 }} size="small">
            <InputLabel id="status-select-label">Estado(s)</InputLabel>
            <Select
              labelId="status-select-label"
              id="status-select"
              multiple
              value={filter.statuses}
              onChange={handleStatusesChange}
              input={<OutlinedInput label="Estado(s)" />}
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return "Todos los estados";
                }
                return selected.length === 1 
                  ? selected[0]
                  : `${selected.length} estados seleccionados`;
              }}
              sx={{
                backgroundColor: 'white',
                '& .MuiSelect-select': {
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 48 * 4.5 + 8,
                    width: 250,
                  },
                },
              }}
            >
              <MenuItem value="all">
                <Checkbox 
                  checked={filter.statuses.length === [...new Set(shipments.map(shipment => shipment.status))].length}
                  indeterminate={filter.statuses.length > 0 && filter.statuses.length < [...new Set(shipments.map(shipment => shipment.status))].length} 
                />
                <ListItemText primary={filter.statuses.length === [...new Set(shipments.map(shipment => shipment.status))].length ? "Deseleccionar todos" : "Seleccionar todos"} />
              </MenuItem>                {[...new Set(shipments.map(shipment => shipment.status))]
                  .sort((a, b) => a.localeCompare(b))
                  .map(status => (
                    <MenuItem key={status} value={status}>
                      <Checkbox checked={filter.statuses.includes(status)} />
                      <ListItemText primary={status} />
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>
          
          {/* Filtro de subestado - aparece solo cuando hay estados seleccionados */}
          {filter.statuses.length > 0 && availableSubstatuses.length > 0 && (
            <FormControl sx={{ width: 220 }} size="small">
              <InputLabel id="substatus-select-label">Subestado(s)</InputLabel>
              <Select
                labelId="substatus-select-label"
                id="substatus-select"
                multiple
                value={filter.substatuses}
                onChange={handleSubstatusesChange}
                input={<OutlinedInput label="Subestado(s)" />}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return "Todos los subestados";
                  }
                  return selected.length === 1 
                    ? selected[0]
                    : `${selected.length} subestados seleccionados`;
                }}
                sx={{
                  backgroundColor: 'white',
                  '& .MuiSelect-select': {
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 48 * 4.5 + 8,
                      width: 250,
                    },
                  },
                }}
              >
                <MenuItem value="all">
                  <Checkbox 
                    checked={filter.substatuses.length === availableSubstatuses.length}
                    indeterminate={filter.substatuses.length > 0 && filter.substatuses.length < availableSubstatuses.length} 
                  />
                  <ListItemText primary={filter.substatuses.length === availableSubstatuses.length ? "Deseleccionar todos" : "Seleccionar todos"} />
                </MenuItem>                {availableSubstatuses.map(substatus => (
                  <MenuItem key={substatus} value={substatus}>
                    <Checkbox checked={filter.substatuses.includes(substatus)} />
                    <ListItemText primary={substatus || 'N/A'} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>          )}          {/* Separador para filtros avanzados */}
          <div className="w-full">
            <div className="flex items-center my-2">
              <div className="flex-grow border-t border-gray-300"></div>
              <button
                onClick={() => setIsAdvancedFiltersExpanded(!isAdvancedFiltersExpanded)}
                className="flex items-center px-3 py-1 hover:bg-gray-100 rounded-md transition-colors duration-200"
              >
                <div className="w-1 h-1 bg-sky-400 rounded-full mr-2"></div>
                <span className="text-xs font-medium text-gray-600 mr-2">Filtros Avanzados</span>
                <ChevronDown 
                  className={`w-4 h-4 text-gray-600 transition-transform duration-200 ${
                    isAdvancedFiltersExpanded ? 'rotate-180' : ''
                  }`}
                />
              </button>
              <div className="flex-grow border-t border-gray-300"></div>
            </div>
          </div>

          {/* Filtros Avanzados Colapsables */}
          {isAdvancedFiltersExpanded && (
            <>              {/* Filtro de Operadores con Autocomplete */}              <Autocomplete
                multiple
                size="small"
                id="operators-autocomplete"
                options={[...new Set(originalShipments.map(s => s.driver).filter(Boolean).filter(driver => driver !== "undefined undefined"))].sort((a, b) => a.localeCompare(b))}
                value={filter.operators}
                onChange={(event, newValue) => {
                  setFilter(prev => ({
                    ...prev,
                    operators: newValue
                  }));
                }}
                disableCloseOnSelect
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    label="Operador(es)" 
                    placeholder={filter.operators.length === 0 ? "Todos los operadores" : "Buscar operadores..."} 
                  />
                )}
                renderTags={(tagValue, getTagProps) =>
                  tagValue.length > 1 ? (
                    <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                      {tagValue.length} operadores seleccionados
                    </span>
                  ) : (
                    tagValue.map((option, index) => (
                      <span key={index} style={{ fontSize: '0.875rem' }}>
                        {option}
                      </span>
                    ))
                  )
                }
                isOptionEqualToValue={(option, value) => option === value}
                sx={{
                  width: 220,
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: 'white',
                  }
                }}
              />{/* Filtro de Unidades con Autocomplete */}          <Autocomplete
            multiple
            size="small"
            id="units-autocomplete"
            options={[...new Set(originalShipments.map(s => s.vehicle).filter(Boolean))].sort((a, b) => a.localeCompare(b))}
            value={filter.units}
            onChange={(event, newValue) => {
              setFilter(prev => ({
                ...prev,
                units: newValue
              }));
            }}
            disableCloseOnSelect
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </li>
            )}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Unidad(es)" 
                placeholder={filter.units.length === 0 ? "Todas las unidades" : "Buscar unidades..."} 
              />
            )}
            renderTags={(tagValue, getTagProps) =>
              tagValue.length > 1 ? (
                <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                  {tagValue.length} unidades seleccionadas
                </span>
              ) : (
                tagValue.map((option, index) => (
                  <span key={index} style={{ fontSize: '0.875rem' }}>
                    {option}
                  </span>
                ))
              )
            }
            isOptionEqualToValue={(option, value) => option === value}
            sx={{
              width: 220,
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'white',
              }
            }}
          />{/* Filtro de LT (Línea de Transporte) con Autocomplete */}          <Autocomplete
            multiple
            size="small"
            id="lts-autocomplete"
            options={[...new Set(originalShipments.map(s => s.Lt).filter(Boolean))].sort((a, b) => a.localeCompare(b))}
            value={filter.lts}
            onChange={(event, newValue) => {
              setFilter(prev => ({
                ...prev,
                lts: newValue
              }));
            }}
            disableCloseOnSelect
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </li>
            )}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="LT" 
                placeholder={filter.lts.length === 0 ? "Todas las LTs" : "Buscar LTs..."} 
              />
            )}
            renderTags={(tagValue, getTagProps) =>
              tagValue.length > 1 ? (
                <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                  {tagValue.length} LTs seleccionadas
                </span>
              ) : (
                tagValue.map((option, index) => (
                  <span key={index} style={{ fontSize: '0.875rem' }}>
                    {option}
                  </span>
                ))
              )
            }
            isOptionEqualToValue={(option, value) => option === value}
            sx={{
              width: 220,
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'white',
              }
            }}
          />
            </>          )}
        </Stack>
      </CardContent>
    </Card>

        <div className="mb-4 mt-6 grid gap-6 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4">
          <Card className="shadow-lg hover:shadow-2xl transition-all duration-300">
            <CardHeader className="flex flex-row items-center space-y-0">
              <CardTitle className="text-sm font-medium">Total de embarques</CardTitle>
              <Package className="ml-auto h-6 w-6 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-semibold text-gray-900">{stats.totalShipments}</div>
            </CardContent>
          </Card>

          <Card className="shadow-lg hover:shadow-2xl transition-all duration-300">
            <CardHeader className="flex flex-row items-center space-y-0">
              <CardTitle className="text-sm font-medium">Embarques Finalizados</CardTitle>
              <Check className="ml-auto h-6 w-6 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-semibold text-gray-900">{stats.delivered}</div>
            </CardContent>
          </Card>

          <Card className="shadow-lg hover:shadow-2xl transition-all duration-300">
            <CardHeader className="flex flex-row items-center space-y-0">
              <CardTitle className="text-sm font-medium">Embarques Activos</CardTitle>
              <Truck className="ml-auto h-6 w-6 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-semibold text-gray-900">{stats.asign + stats.pending + stats.inTransit + stats.client + stats.arrived}</div>
            </CardContent>
          </Card>
        </div>

        <div className="relative"> 
          <Card className="shadow-lg" style={{ maxWidth: '100%' }}>
            <CardHeader className="bg-gray-800 text-white">
              <CardTitle>Embarques</CardTitle>
            </CardHeader>
            <CardContent className="bg-white">
              <Table className="table-auto w-full">
                <TableHeader className="bg-gray-200">
                  <TableRow>
                    <TableHead className="px-2 py-2 w-10"></TableHead>
                    <TableHead className="px-4 py-2 text-left">Referencia</TableHead>
                    <TableHead className="px-4 py-2 text-left">Truck</TableHead>
                    <TableHead className="px-4 py-2 text-left">Consignatario</TableHead>
                    <TableHead className="px-4 py-2 text-left">Orden</TableHead>
                    <TableHead className="px-4 py-2 text-left">Destino</TableHead>
                    <TableHead className="px-4 py-2 text-left">LT</TableHead>
                    <TableHead className="px-4 py-2 text-left">Unidad</TableHead>
                    <TableHead className="px-4 py-2 text-left">Operador</TableHead>
                    <TableHead className="px-4 py-2 text-left">Estatus</TableHead>
                    <TableHead className="px-4 py-2 text-left">Subestatus</TableHead>
                    <TableHead className="px-4 py-2 text-left">Fecha Carga</TableHead>
                    <TableHead className="px-4 py-2 text-left">Fecha Entrega</TableHead>
                    <TableHead className="px-4 py-2 text-left">Devolucion</TableHead>
                    <TableHead className="px-4 py-2 text-left">Acciones</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {paginatedShipments.map((shipment) => (
                    <ShipmentRow
                      key={shipment.id}
                      shipment={shipment}
                      actions={renderActions}
                      formatDate={formatDate}
                      getStatusBadge={getStatusBadge}
                      getDevStatusDotColor={getDevStatusDotColor}
                      getFormattedDateTime={getFormattedDateTime}
                      toggleShipmentExpand={toggleShipmentExpand}
                      warehouseData={warehouseData}
                      handlePutOnHold={handlePutOnHold}
                      handleRemoveFromHold={handleRemoveFromHold}
                    />
                  ))}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </div>

        <div className="mt-6 flex justify-between items-center">
          {/* Paginación - Nuevos botones y lógica */}
          <div className="flex gap-2">
            <Button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
              variant="outline"
              className="text-gray-700 border-gray-300 hover:bg-gray-100"
            >
              <ChevronLeft className="h-5 w-5" />
            </Button>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              variant="outline"
              className="text-gray-700 border-gray-300 hover:bg-gray-100"
            >
              Anterior
            </Button>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              variant="outline"
              className="text-gray-700 border-gray-300 hover:bg-gray-100"
            >
              Siguiente
            </Button>
            <Button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
              variant="outline"
              className="text-gray-700 border-gray-300 hover:bg-gray-100"
            >
              <ChevronRight className="h-5 w-5" />
            </Button>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-500">Filas por página:</span>
            <Select
              value={rowsPerPage}
              onChange={(e) => handleRowsPerPageChange(parseInt(e.target.value))}
              variant="outlined"
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'white',
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#0ea5e9',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#0ea5e9',
                  },
                },
                '& .MuiSelect-select': {
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 12px',
                },
              }}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </div>
        </div>

        <div className="mt-6"></div>
        
        <Modal
          isOpen={isModalOpen}
          onClose={() => setModalOpen(false)}
          newShipment={newShipment}
          setNewShipment={setNewShipment}
          onSave={() => {
            setModalOpen(false);
            fetchShipments();
          }}
        />
      <SettingModal
          isOpen={isSettingModalOpen}
          onClose={handleCloseSettingModal}
          shipment={selectedShipmentForSetting}
          availableOrders={ordersForAssign} 
          fetchShipments={fetchShipments}
        />

        <Miuimodal open={isMiuimodalOpen} onClose={handleCloseMiuimodal}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 300,
              bgcolor: 'background.paper',
              borderRadius: '10px',
              boxShadow: 24,
              p: 4,
              textAlign: 'center',
            }}
          >
            <Typography variant="h6" component="h2">
              Confirmación de Eliminación
            </Typography>
            <Typography sx={{ mt: 2 }}>
              ¿Estás seguro de que deseas eliminar el embarque <b>{shipmentToDelete?.reference}</b>?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button variant="outline" onClick={handleCloseMiuimodal} className="mr-2">
                Cancelar
              </Button>
              <Button variant="destructive" onClick={handleConfirmDelete}>
                Confirmar
              </Button>
            </Box>
          </Box>
        </Miuimodal>

        <ConfirmationModal
          isOpen={isConfirmationModalOpen}
          onClose={handleCloseConfirmationModal}
          onConfirm={revertShipment}
          message="¿Estás seguro de que deseas revertir este embarque? Esta acción no se puede deshacer."
        />

        <CommentsModal
          isOpen={isCommentsModalOpen}
          onClose={handleCloseCommentsModal}
          comments={selectedShipmentComments}
          onAddComment={handleAddComment}
        />

        {isStatusModalOpen && (
          <ModalEstatus
            shipment={selectedShipmentRef}
            onClose={() => setStatusModalOpen(false)}
            refreshShipments={fetchShipments}
          />
        )}

        {isEntregaModalOpen && (
          <ModalEntrega
            onClose={() => setEntregaModalOpen(false)}
            referencia={referencia}
            shipment={selectedShipmentRef}
            refreshShipments={fetchShipments}
          />
        )}

        <AdditionalCostsModal 
          isOpen={isAdditionalCostsModalOpen}
          onClose={handleCloseAdditionalCostsModal}
          shipmentRef={selectedShipmentForCosts}
        />
      </div>
    </div>
  );
};

export default Shipments;

<style jsx>{`
  .filter-container {
    display: flex;
    align-items: center;
  }
  .react-datepicker-wrapper {
    width: 100%;
  }
  .react-datepicker__input-container input {
    background-color: white;
    border-radius: 4px;
    border: 1px solid #d1d5db;
    padding: 8px 12px;
    font-size: 14px;
    width: 100%;
    height: 38px;
  }
  .react-datepicker__input-container input:focus {
    outline: none;
    border-color: #9ca3af;
    box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.5);
  }
  .date-picker-popper {
    z-index: 9999 !important;
  }
  .datepicker-popper-container {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 9999 !important;
    margin-top: 8px;
  }  /* Animación de respiración para la fila de resguardo */
  .row-breathing {
    animation: rowBreathing 1.8s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    will-change: box-shadow, background-color, opacity;
    box-shadow: 0 0 0 0 rgba(251, 191, 36, 0.7);
    background-color: #fef3c7 !important;
    transition: background-color 0.3s;
  }
  /* Estilos para DatePicker */
  .react-datepicker-popper {
    z-index: 9999 !important;
  }
  
  .react-datepicker {
    z-index: 9999 !important;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important;
    border: 1px solid #e5e7eb !important;
  }
  
  .react-datepicker__portal {
    z-index: 9999 !important;
  }
  
  .react-datepicker__portal .react-datepicker {
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important;
    border: 1px solid #e5e7eb !important;
  }
  
  .datepicker-popper-container {
    z-index: 9999 !important;
  }
  
  .date-picker-popper {
    z-index: 9999 !important;
  }

  @keyframes rowBreathing {
    0% {
      box-shadow: 0 0 0 0 rgba(251, 191, 36, 0.7);
      background-color: #fef3c7;
      opacity: 1;
    }
    50% {
      box-shadow: 0 0 32px 16px rgba(251, 191, 36, 0.25);
      background-color: #fde68a;
      opacity: 0.7;
    }
    100% {
      box-shadow: 0 0 0 0 rgba(251, 191, 36, 0.7);
      background-color: #fef3c7;
      opacity: 1;
    }
  }
`}</style>